import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Sentinel</h3>
            <p className="footer-description">
              {t('footer.description') || 'Advanced Security Monitoring & Policy Management for Kubernetes'}
            </p>
          </div>

          <div className="footer-section">
            <h4>{t('footer.product') || 'Product'}</h4>
            <ul>
              <li><a href="#/">Dashboard</a></li>
              <li><a href="#/analysis/events">Events</a></li>
              <li><a href="#/analysis/policies">Policies</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.company') || 'Company'}</h4>
            <ul>
              <li><a href="https://accuknox.com" target="_blank" rel="noopener noreferrer">AccuKnox</a></li>
              <li><a href="https://kubearmor.io" target="_blank" rel="noopener noreferrer">KubeArmor</a></li>
              <li><a href="#/">About</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.legal') || 'Legal'}</h4>
            <ul>
              <li><a href="#/">Privacy Policy</a></li>
              <li><a href="#/">Terms of Service</a></li>
              <li><a href="#/">License</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            {t('footer.copyright') || `© ${currentYear} kim seok joon. All rights reserved.`}
          </p>
          <p className="footer-version">
            Sentinel v1.0.0
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
